module.exports = __webpack_public_path__ + "static/media/sa3.c6931abd.jpg";